import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  minYear: z.number().int().optional(),
  maxYear: z.number().int().optional(),
});

export const monthYearField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "month_year",
  label: "Month and year",
  category: "date_time",
  icon: "CalendarDays",
  configSchema,
  valueSchema: (config, isRequired) => {
    const base = z
      .string()
      .regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Enter a valid month and year (YYYY-MM)")
      .superRefine((value, ctx) => {
        const year = Number(value.slice(0, 4));
        if (config.minYear !== undefined && year < config.minYear) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Must be ${config.minYear} or later`,
          });
        }
        if (config.maxYear !== undefined && year > config.maxYear) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Must be ${config.maxYear} or earlier`,
          });
        }
      });
    return optionalUnlessRequired(base, isRequired);
  },
  defaultConfig: {},
  supportsProfileBinding: true,
  defaultSearchable: false,
  renderHints: {},
};
